"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ARIA;
(function (ARIA) {
    ARIA["ACTIVE_DESCENDANTS"] = "aria-activedescendant";
    ARIA["ATOMIC"] = "aria-atomic";
    ARIA["AUTOCOMPLETE"] = "aria-autocomplete";
    ARIA["BUSY"] = "aria-busy";
    ARIA["CHECKED"] = "aria-checked";
    ARIA["CONTROLS"] = "aria-controls";
    ARIA["DESCRIBED_BY"] = "aria-describedby";
    ARIA["DISABLED"] = "aria-disabled";
    ARIA["DROP_EFFECT"] = "aria-dropeffect";
    ARIA["ERROR_MESSAGE"] = "aria-errormessage";
    ARIA["EXPANDED"] = "aria-expanded";
    ARIA["FLOW_TO"] = "aria-flowto";
    ARIA["GRABBED"] = "aria-grabbed";
    ARIA["HAS_POPUP"] = "aria-haspopup";
    ARIA["HIDDEN"] = "aria-hidden";
    ARIA["INVALID"] = "aria-invalid";
    ARIA["LABEL"] = "aria-label";
    ARIA["LABELLED_BY"] = "aria-labelledby";
    ARIA["LEVEL"] = "aria-level";
    ARIA["LIVE"] = "aria-live";
    ARIA["MODAL"] = "aria-modal";
    ARIA["MULTI_LINE"] = "aria-multiline";
    ARIA["MULTI_SELECTABLE"] = "aria-multiselectable";
    ARIA["ORIENTATION"] = "aria-orientation";
    ARIA["OWNS"] = "aria-owns";
    ARIA["PLACEHOLDER"] = "aria-placeholder";
    ARIA["POINT_SET"] = "aria-posinset";
    ARIA["PRESSED"] = "aria-pressed";
    ARIA["READ_ONLY"] = "aria-readonly";
    ARIA["RELEVANT"] = "aria-relevant";
    ARIA["REQUIRED"] = "aria-required";
    ARIA["SELECTED"] = "aria-selected";
    ARIA["SET_SIZE"] = "aria-setsize";
    ARIA["SORT"] = "aria-sort";
    ARIA["VALUE_MAX"] = "aria-valuemax";
    ARIA["VALUE_MIN"] = "aria-valuemin";
    ARIA["VALUE_NOW"] = "aria-valuenow";
    ARIA["VALUE_TEXT"] = "aria-valuetext";
})(ARIA || (ARIA = {}));
exports.default = ARIA;
//# sourceMappingURL=ARIA.js.map